import { Translations } from '../types';

export const id: Translations = {
  common: {
    loading: 'Memuat...',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    save: 'Simpan',
    delete: 'Hapus',
    edit: 'Edit',
    back: 'Kembali',
    next: 'Selanjutnya',
    submit: 'Kirim',
    search: 'Cari',
    filter: 'Filter',
    all: 'Semua',
    viewAll: 'Lihat Semua',
    copy: 'Salin',
    copied: 'Tersalin!',
    success: 'Berhasil',
    error: 'Error',
    close: 'Tutup',
  },
  nav: {
    home: 'Beranda',
    linkExchange: 'Hubungkan Exchange',
    rebate: 'Rebate',
    exchanges: 'Exchanges',
    withdraw: 'Tarik',
    history: 'Riwayat',
    checkIn: 'Check In',
    profile: 'Profil',
    overview: 'Ringkasan',
    rewardHub: 'Pusat Hadiah',
    settings: 'Pengaturan',
  },
  dashboard: {
    title: 'Selamat datang, {name}!',
    subtitle: 'Ringkasan akun Anda',
    balance: 'Saldo',
    totalEarned: 'Total Penghasilan',
    pendingRebate: 'Rebate Tertunda',
    availablePoints: 'XP Tersedia',
    recentRebates: 'Rebate Terbaru',
    recentWithdrawals: 'Penarikan Terbaru',
  },
  linkExchange: {
    title: 'Hubungkan Akun Exchange',
    subtitle: 'Hubungkan UID exchange Anda untuk mengaktifkan pelacakan biaya otomatis',
    exchange: 'Exchange',
    uid: 'UID',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    linkAccount: 'Hubungkan Akun',
    linkedAccounts: 'Akun Terhubung',
    status: 'Status',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    delete: 'Hapus Akun',
    selectExchange: 'Pilih Exchange',
    enterUID: 'Masukkan UID',
    enterApiKey: 'Masukkan API Key',
    enterApiSecret: 'Masukkan API Secret',
    accountLinked: 'Akun berhasil dihubungkan',
    accountDeleted: 'Akun berhasil dihapus',
    binance: 'Binance',
    bybit: 'Bybit',
    okx: 'OKX',
    gate: 'Gate.io',
  },
  rebate: {
    title: 'Rebate Biaya Trading',
    subtitle: 'Riwayat pembayaran rebate otomatis',
    totalRebate: 'Total Rebate',
    pendingRebate: 'Rebate Tertunda',
    balance: 'Saldo',
    withdraw: 'Tarik',
    rebateHistory: 'Riwayat Rebate',
    date: 'Tanggal',
    amount: 'Jumlah',
    status: 'Status',
    completed: 'Selesai',
    pending: 'Tertunda',
    failed: 'Gagal',
    description: 'Deskripsi',
    autoRebate: 'Rebate Otomatis',
    autoRebateDesc: 'Sistem akan secara otomatis memberikan rebate biaya trading ke akun Anda. Waktu pemrosesan: 1-3 hari kerja.',
  },
  withdraw: {
    title: 'Tarik',
    subtitle: 'Tarik dana ke dompet Anda',
    availableBalance: 'Saldo Tersedia',
    withdrawAmount: 'Jumlah Penarikan',
    walletAddress: 'Alamat Dompet (atau UID)',
    network: 'Jaringan',
    selectNetwork: 'Pilih Jaringan',
    enterAmount: 'Masukkan jumlah',
    enterWalletAddress: 'Masukkan alamat dompet (atau UID)',
    withdraw: 'Tarik',
    minWithdraw: 'Penarikan minimum: {amount}',
    fee: 'Biaya',
    receiveAmount: 'Anda akan menerima',
    withdrawHistory: 'Riwayat Penarikan',
    processing: 'Memproses',
    completed: 'Selesai',
    failed: 'Gagal',
    trc20: 'TRC20',
    erc20: 'ERC20',
    bep20: 'BEP20',
    pleaseEnterAmount: 'Silakan masukkan jumlah yang valid',
    pleaseEnterWallet: 'Silakan masukkan alamat dompet',
    pleaseSelectNetwork: 'Silakan pilih jaringan',
    invalidAmount: 'Jumlah tidak valid',
    amountTooLow: 'Jumlah di bawah penarikan minimum',
    insufficientBalance: 'Saldo tidak cukup',
    confirmWithdrawal: 'Konfirmasi Penarikan',
    withdrawalSubmitted: 'Permintaan penarikan berhasil dikirim! Periksa Riwayat untuk melihat status klaim.',
    withdrawalFailed: 'Penarikan gagal',
    note: 'Catatan',
    withdrawalNote: 'Biaya gas akan dikurangkan dari jumlah penarikan',
  },
  history: {
    title: 'Riwayat Transaksi',
    subtitle: 'Lihat semua transaksi dan penarikan Anda',
    transactions: 'Transaksi',
    withdrawals: 'Penarikan',
    rebates: 'Rebate',
    date: 'Tanggal',
    type: 'Tipe',
    amount: 'Jumlah',
    status: 'Status',
    noTransactions: 'Tidak ada transaksi ditemukan',
    noWithdrawals: 'Tidak ada penarikan ditemukan',
    noRebates: 'Tidak ada rebate ditemukan',
    claimNow: 'Klaim Sekarang',
    claiming: 'Mengklaim...',
    readyToClaim: 'Siap untuk diklaim dari smart contract',
    claimedSuccessfully: 'Berhasil diklaim!',
    failedToClaim: 'Gagal mengklaim',
    noMoreItems: 'Tidak ada lagi item',
    payGas: 'Bayar Gas',
    claimed: 'Diklaim',
    noHistoryFound: 'Tidak ada riwayat ditemukan',
    statusCompleted: 'Selesai',
    statusPending: 'Tertunda',
    statusFailed: 'Gagal',
    statusProcessing: 'Memproses',
    statusRejected: 'Ditolak',
  },
  checkIn: {
    title: 'Check In Harian',
    subtitle: 'Check in setiap hari untuk mendapatkan poin',
    checkIn: 'Check In',
    checkedIn: 'Sudah Check In',
    todayPoints: 'XP Hari Ini',
    totalPoints: 'Total XP',
    points: 'XP',
    redeem: 'Tukar',
    rewards: 'Hadiah',
    vouchers: 'Voucher',
    linkReward: 'Hadiah Hubungkan',
    linkExchange: 'Hubungkan Akun Exchange',
    linkRewardDesc: 'Hubungkan akun exchange Anda untuk menerima poin bonus',
    rewardHistory: 'Riwayat Hadiah',
    availableRewards: 'Hadiah Tersedia',
    voucher: 'Voucher',
    gift: 'Hadiah',
    pointsRequired: 'XP Diperlukan',
    redeemNow: 'Tukar Sekarang',
    redeemed: 'Ditukar',
    noRewards: 'Tidak ada hadiah tersedia',
    shop: 'Toko',
    myCodes: 'Kode Saya',
    backButton: '← Kembali',
    noPointsHistory: 'Tidak ada riwayat XP',
    myRedeemedCodes: 'Kode yang Sudah Ditukar',
    yourCode: 'Kode Anda:',
    codeCopied: 'Kode disalin!',
    noRedeemedYet: 'Belum ada hadiah yang ditukar',
    dailyCheckIn: 'Check In Harian',
    tasks: 'Tugas',
    checkedInSuccessfully: 'Check in berhasil!',
    checkInFailed: 'Check in gagal',
    claimedTask: 'Tugas berhasil diklaim!',
    failedToClaimTask: 'Gagal mengklaim tugas',
    insufficientPoints: 'XP tidak cukup',
    redeemFailed: 'Penukaran gagal',
    special: 'Khusus',
    social: 'Sosial',
    trading: 'Trading',
    watchAd: 'Tonton Iklan',
    available: 'tersedia',
    completed: 'selesai',
    comingSoon: 'Segera Hadir',
    times: 'kali',
    weeklyLeaderboard: 'Peringkat XP Mingguan',
    leaderboardSubtitle: 'Pemain terbaik minggu ini',
    yourRank: 'Peringkat Anda',
    yourXP: 'XP Anda',
    you: 'Anda',
    noLeaderboardData: 'Belum ada data peringkat',
    prize: 'Hadiah',
  },
  profile: {
    title: 'Profil',
    accountInfo: 'Informasi Akun',
    telegramId: 'Telegram ID',
    joinDate: 'Tanggal Bergabung',
    language: 'Bahasa',
    english: 'Bahasa Inggris',
    vietnamese: 'Bahasa Vietnam',
    spanish: 'Bahasa Spanyol',
    portuguese: 'Bahasa Portugis',
    chinese: 'Bahasa Mandarin',
    indonesian: 'Bahasa Indonesia',
    emailSettings: 'Pengaturan Email',
    notSet: 'Belum diatur',
    logout: 'Keluar',
    logoutConfirm: 'Apakah Anda yakin ingin keluar?',
  },
  login: {
    title: 'CashBackHub',
    subtitle: 'Sistem Rebate Biaya Trading',
    description: 'Telegram Mini App',
    hint: 'Silakan buka aplikasi dari Telegram',
    login: 'Masuk',
  },
  exchanges: {
    title: 'Exchanges',
    subtitle: 'Pilih tipe referral Anda',
    chooseReferralType: 'Pilih tipe referral Anda',
    exchangeReferral: 'Referral Exchange',
    linkYourUid: 'Hubungkan UID Anda',
    copyTrade: 'Copy Trade',
    followTrades: 'Ikuti trading kami',
    filterByExchange: 'Filter berdasarkan exchange:',
    allExchanges: 'Semua Exchange',
    accounts: 'akun',
    account: 'Akun',
    connected: 'Terhubung',
    uidCopied: 'UID disalin!',
    totalRebate: 'Total Rebate',
    transactionVolume: 'Volume Transaksi',
    waitingForSync: 'Menunggu sinkronisasi',
    cashbackHubRebate: 'Rebate CashbackHub',
    viewReason: 'Lihat Alasan',
    reconnect: 'Hubungkan Kembali',
    noAccounts: 'Belum ada akun exchange',
    rejectionReason: 'Alasan Penolakan',
    exchangeConnected: 'Exchange berhasil terhubung!',
    notConfigured: 'Belum dikonfigurasi',
    noExchangesAvailable: 'Tidak Ada Exchange Tersedia',
    pleaseContactSupport: 'Silakan hubungi tim dukungan kami untuk mengatur exchange untuk akun Anda.',
    allAccounts: 'Semua',
    activeAccounts: 'Aktif',
    pendingAccounts: 'Menunggu',
    rejectedAccounts: 'Ditolak',
    totalProfit: 'Total Profit',
    noCopyTradeAccounts: 'Belum ada akun copy trade',
    rejectionReasonText: 'UID ini belum terdaftar dalam sistem referral kami. Silakan hubungi tim dukungan kami @backcashhub untuk mendapatkan instruksi detail tentang cara menyelesaikan proses registrasi!',
  },
  settings: {
    title: 'Pengaturan',
    subtitle: 'Sesuaikan pengalaman Anda dan kelola detail akun Anda',
    telegramNotifications: 'Notifikasi Telegram',
    profile: 'Profil',
    telegramNotificationsDesc: 'Dapatkan pembaruan instan melalui Telegram',
    uid: 'UID',
    connected: 'Terhubung',
    connect: 'Hubungkan',
    emailVerification: 'Verifikasi Email',
    emailAddress: 'Alamat Email',
    sendVerificationCode: 'Kirim Kode Verifikasi',
    sending: 'Mengirim...',
    verificationCode: 'Kode Verifikasi',
    enterCode: 'Masukkan kode 6 digit dari email Anda',
    changeEmail: 'Ganti Email',
    resendCode: 'Kirim Ulang Kode',
    verifying: 'Memverifikasi...',
    verifyEmail: 'Verifikasi Email',
    codeExpired: 'Kode verifikasi telah kedaluwarsa. Silakan minta kode baru.',
    invalidCode: 'Kode verifikasi tidak valid. Silakan coba lagi.',
    verificationSent: 'Kode verifikasi berhasil dikirim! Periksa email Anda.',
    emailVerified: 'Email berhasil diverifikasi!',
    failedToSend: 'Gagal mengirim kode verifikasi. Silakan coba lagi.',
    failedToVerify: 'Gagal memverifikasi email. Silakan coba lagi.',
    enterEmailPlaceholder: 'email.anda@example.com',
    enterCodeDesc: 'Masukkan kode 6 digit dari email Anda',
  },
  copyTrade: {
    title: 'Copy Trade',
    notConfigured: 'Belum dikonfigurasi',
    noExchangesAvailable: 'Tidak Ada Exchange Tersedia',
    pleaseContactSupport: 'Silakan hubungi tim dukungan kami untuk mengatur exchange untuk akun Anda.',
    linkCopyTradeAccount: 'Hubungkan Akun Copy Trade',
    selectExchange: 'Pilih Exchange',
    step1: 'Langkah 1: Klik tombol di bawah untuk copy trade',
    openCopyTradeLink: 'Buka Link Copy Trade',
    clickToCopyTrade: 'Klik untuk membuka link copy trade kami dan ikuti instruksinya',
    step2: 'Langkah 2: Masukkan UID Anda',
    enterYourUid: 'Masukkan UID Anda',
    enterUidPlaceholder: 'Masukkan UID Anda di exchange',
    submit: 'Kirim',
    submitting: 'Mengirim...',
    pleaseEnterUid: 'Silakan masukkan UID Anda',
    pleaseSelectExchange: 'Silakan pilih exchange',
    pleaseSelectBot: 'Silakan pilih bot',
    submittedSuccessfully: 'Akun copy trade berhasil dikirim! Tunggu persetujuan.',
    accountRejectedPleaseResubmit: 'Akun Anda ditolak. Silakan kirim ulang dengan informasi yang benar.',
    disabled: 'Dinonaktifkan',
    accountDisabledMessage: 'Akun ini telah dinonaktifkan. Silakan hubungi dukungan untuk informasi lebih lanjut.',
    submitFailed: 'Gagal mengirim akun copy trade',
  },
  rules: {
    title: 'Aturan Cashback',
    description: 'Persentase cashback berdasarkan tonggak keuntungan:',
    profitRange: 'Rentang Keuntungan',
    rebatePercentage: 'Cashback',
    range1: '$100 - $200',
    range2: '$201 - $300',
    range3: '$301 - $400',
    range4: '$500+',
    note: 'Cashback dihitung berdasarkan keuntungan tambahan setelah dikurangi cashback dari exchange.',
    noRules: 'Tidak ada aturan cashback tersedia',
  },
};

